import React from 'react';

const SOLUTIONS = [
  {
    title: 'Abandoned Freight Resolution',
    description:
      'Convert costly dock congestion into recovered capital with our compliant, end-to-end abandoned freight management service.',
    icon: 'truck',
  },
  {
    title: 'IT Asset Disposition & Recycling',
    description:
      'Securely retire corporate IT assets with certified data destruction, compliant processing, and maximum value recovery.',
    icon: 'laptop',
  },
  {
    title: 'Store Closing & Liquidation',
    description:
      'Convert remaining inventory into working capital quickly during business transitions with our experienced merchandising team.',
    icon: 'store',
  },
  {
    title: 'Charitable Donation Programs',
    description:
      'Support your community while receiving tax benefits and detailed impact reporting for your non-sellable but usable inventory.',
    icon: 'gift',
  },
  {
    title: 'Customer Returns Processing',
    description:
      'Convert costly returns into recoverable assets with our streamlined intake, evaluation, and resale process that maintains brand protection.',
    icon: 'rotate',
  },
  {
    title: 'Excess Inventory Liquidation & Optimization',
    description:
      'Free up space and cash by routing surplus or seasonal inventory to the highest-value channels with data-driven pricing and global buyers.',
    icon: 'cart',
  },
];

const Icon = ({ name }) => {
  const common = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  switch (name) {
    case 'truck':
      return (
        <svg {...common}>
          <rect x="1.5" y="7" width="11" height="8" rx="1.5" />
          <path d="M12.5 9h4l3 3v3h-3.5" />
          <circle cx="6" cy="17.5" r="1.5" />
          <circle cx="16" cy="17.5" r="1.5" />
        </svg>
      );
    case 'laptop':
      return (
        <svg {...common}>
          <rect x="4" y="5" width="16" height="10" rx="1.5" />
          <path d="M2 19h20" />
        </svg>
      );
    case 'store':
      return (
        <svg {...common}>
          <path d="M3 10h18l-1.5-4.5a2 2 0 0 0-1.9-1.3H6.4a2 2 0 0 0-1.9 1.3L3 10z" />
          <path d="M5 10v8h14v-8" />
          <path d="M9 18v-4h6v4" />
        </svg>
      );
    case 'gift':
      return (
        <svg {...common}>
          <rect x="3" y="9" width="18" height="11" rx="2" />
          <path d="M3 12h18M12 9v11" />
          <path d="M7.5 6a2.5 2.5 0 1 1 4 2.5H8a2 2 0 0 1-2-2 2 2 0 0 1 1.5-2.5zM16.5 6A2.5 2.5 0 1 0 12 8.5h3.5a2 2 0 0 0 2-2z" />
        </svg>
      );
    case 'rotate':
      return (
        <svg {...common}>
          <path d="M20 12a8 8 0 1 1-2.34-5.66" />
          <path d="M20 4v6h-6" />
        </svg>
      );
    case 'cart':
      return (
        <svg {...common}>
          <circle cx="9" cy="19" r="1.5" />
          <circle cx="17" cy="19" r="1.5" />
          <path d="M3 5h2l2.2 9.5a1.5 1.5 0 0 0 1.46 1.2H17a1.5 1.5 0 0 0 1.46-1.2L20 9H7" />
        </svg>
      );
    default:
      return null;
  }
};

const RotatingSolutions = () => {
  // Duplicate list for seamless marquee
  const items = [...SOLUTIONS, ...SOLUTIONS];

  return (
    <section className="rotating">
      <div className="rotating-track">
        {items.map((item, idx) => (
          <article key={idx} className="rotating-card">
            <div className="rotating-icon"><Icon name={item.icon} /></div>
            <h3 className="rotating-title">{item.title}</h3>
            <p className="rotating-desc">{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default RotatingSolutions;


